/**
 * ★ Fase 91 (Doc 02) — FAQ riutilizzabile per le landing scure (Bali / Lombok).
 * Usa l'Accordion Shadcn; tema dark coerente con la palette funnel (INK / GOLD / IVORY).
 * Traccia `faq_open` (solo con consenso analytics) per capire quali domande contano.
 */
import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { trackFunnelEvent } from '../../lib/attribution';

const GOLD = '#D6B25E';
const IVORY = '#F4EEE1';
const SAND = '#CFC6B2';

export function FaqAccordion({ items = [], kicker, title, intro, funnel, theme = 'dark', testIdPrefix = 'faq', id = 'faq', className = '' }) {
  if (!items.length) return null;
  const dark = theme === 'dark';
  const onOpen = (val) => {
    if (!val) return;
    const idx = Number(String(val).replace(`${testIdPrefix}-`, ''));
    const item = items[idx];
    if (item) trackFunnelEvent('faq_open', { funnel, label: item.q, position: idx + 1 });
  };
  return (
    <section id={id} className={`scroll-mt-20 ${className}`} data-testid={`${testIdPrefix}-section`}>
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        {kicker && (
          <div className="text-[11px] font-sans font-bold tracking-[0.28em] uppercase" style={{ color: dark ? GOLD : '#5F6B49' }}>{kicker}</div>
        )}
        {title && (
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl leading-[1.08] tracking-tight" style={{ color: dark ? IVORY : '#111A17' }} data-testid={`${testIdPrefix}-title`}>{title}</h2>
        )}
        {intro && (
          <p className="mt-3 text-sm sm:text-[15px] font-sans leading-relaxed" style={{ color: dark ? SAND : '#5A6B67' }}>{intro}</p>
        )}
        <Accordion type="single" collapsible className="mt-7 space-y-3" onValueChange={onOpen}>
          {items.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`${testIdPrefix}-${i}`}
              className="rounded-2xl border px-5"
              style={{
                borderColor: dark ? 'rgba(214,178,94,0.30)' : '#DDD6C4',
                background: dark ? 'rgba(244,238,225,0.04)' : '#FFFFFF',
              }}
              data-testid={`${testIdPrefix}-item-${i + 1}`}
            >
              <AccordionTrigger className="text-left font-serif text-base sm:text-lg py-4 hover:no-underline" style={{ color: dark ? IVORY : '#111A17' }}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="font-sans text-sm sm:text-[15px] leading-relaxed pb-5" style={{ color: dark ? SAND : '#3F4B47' }}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
